import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
export default function NotFound() {
  return <section className="studio-container not-found" id="top"><p className="mono-label">404 / WEB BUILDERS</p><h1 data-testid="not-found-title">Page not found.</h1><Link className="studio-button" data-testid="not-found-home-link" to="/"><ArrowLeft size={18} />Web Builders</Link></section>;
}